import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import CheckboxGroupField from '../forms/checkbox-group-field';
import {
  getEventCategoryOptionsForType
} from '../../utils/event-categories';
import { eventTypes } from '../../utils/events';

const EventFormCategories = ({ disabled, forceTouched }) => {
  const {
    values: { eventType },
  } = useFormikContext();

  return (
    <CheckboxGroupField
      name="categoryIds"
      label={`${eventTypes[eventType].name} Categories (optional)`}
      disabled={disabled}
      touched={forceTouched}
      options={getEventCategoryOptionsForType(eventType)}
    />
  );
};

EventFormCategories.propTypes = {
  disabled: PropTypes.bool.isRequired,
  forceTouched: PropTypes.bool.isRequired,
};

export default EventFormCategories;